<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Applications</a>
        </li>
      </ol>
    </div>    
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row mt-3">
      <div class="col-md-3 mb-3" *ngFor="let application of applications">

        <div class="card h-100 bg-emphasis bg-opacity-25" [ngClass]="{'unavailable' : !application.available}">
          <div class="card-body h-100 p-1 m-2">
            <div class="product-imitation" *ngIf="application.imageUrl == null">
              [ INFO ]
          </div>
          <div class="product-imitation" *ngIf="application.imageUrl != null">
            <img [src]="application.imageUrl">
          </div>
          <div class="product-desc">
              
            <small class="text-muted">{{application.category}}</small>
            <br/>

            <a *ngIf="application.available" [href]="application.infoUrl" class="product-name">{{application.name}}</a>
            <a *ngIf="!application.available" href="#" class="product-name" target="_blank">{{application.name}}</a>

            <div class="small m-t-xs product-sub">
                {{application.description}}
            </div>

            <div class="m-t" style="width: 100%;">
              <span class="m-t text-left" *ngIf="!application.active">
                <a [routerLink]="application.link"  class="btn btn-xs btn-outline btn-danger">Activate <i class="fa fa-long-arrow-right"></i> </a>
              </span>
              <span class="m-t text-left" *ngIf="application.active">
                <a [routerLink]="application.link"  class="btn btn-xs btn-outline btn-danger">Open <i class="fa fa-long-arrow-right"></i> </a>
              </span>
              <span class="product-price" *ngIf="application.price">
                ${{application.price}}
              </span>
            </div>

          </div>
          </div>
        </div>

      </div>

    </div>
  </div>